import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from '../components/CircularProgress';

export default function asyncComponent(importComponent, showSpinner = false) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
      this.showSpinner = showSpinner;
    }

    // componentDidMount substitui componentWillMount
    async componentDidMount() {
      this.mounted = true;

      // Configuração de Nprogress é movida para componentDidMount
      Nprogress.configure({ showSpinner: this.showSpinner });
      Nprogress.start();

      const { default: Component } = await importComponent();
      Nprogress.done();

      if (this.mounted) {
        this.setState({
          component: <Component {...this.props} />
        });
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      const Component =
        this.state.component ||
        (this.showSpinner ? <CircularProgress /> : <></>);
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
